module.exports = __webpack_public_path__ + "img/JE.d0717deb.svg";